<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.Ischecked" :to="onlyOneChild.permissionCode">
        <el-menu-item :index="onlyOneChild.permissionCode" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.iconCls||(item.permissionName&&item.iconCls)" :title="onlyOneChild.permissionName" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="item.permissionCode" popper-append-to-body>
      <template slot="title">
        <item v-if="item.Ischecked" :icon="item.permissionName && item.iconCls" :title="item.permissionName" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.permissionCode"
        :is-nest="true"
        :item="child"
        :base-path="child.permissionCode"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import Item from './Item'
import AppLink from './Link'

export default {
  name: 'sidebar-item',
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {

      const showingChildren = children.filter(item => {
        if (!item.Ischecked) {
          return false
        } else {
          this.onlyOneChild = item;
          return true
        }
      })

      if (showingChildren.length === 1) {//只有一个儿子，不展示父级
        return true
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// SidebarItem.vue?2fc01c37